import React from "react";

import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    CardText,
    Table,
    Button
} from "reactstrap";

import LeafletMap from "components/LeafletMap/LeafletMap.jsx";

class Map extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            showSide: false,
            CurrentVal: "loading...",
            lastSensors: {
              AmbientHumidity: "loading...",
              UV: "loading...",
              AmbientTemp: "loading...",
              BarometerMoisture: "loading...",
              SoilTemp: "loading...",
              SoilMoisture: "loading...",
              BarometerTemp: "loading...",
              WindSpeed: "loading...",
              BarometerPressure: "loading...",
            }
        };
    }

    getLast(array){
      if (!!!array.length){
        return "N/A"
      }else{
        return array[array.length -1];
      }
    }

    setCurrent(store){
      this.setState({
        lastSensors:{
          AmbientHumidity: this.getLast(store.AmbientHumiditySensor.values) + " %",
          UV: this.getLast(store.UVSensor.values) + "",
          AmbientTemp: this.getLast(store.AmbientTempSensor.values) + " \u00b0C",
          BarometerMoisture: this.getLast(store.BarometerMoistureSensor.values) + " %",
          SoilTemp: this.getLast(store.SoilTempSensor.values) +  " \u00b0C",
          SoilMoisture: this.getLast(store.SoilMoistureSensor.values) + " VWC",
          BarometerTemp: this.getLast(store.BarometerTempSensor.values) + " \u00b0C",
          WindSpeed: this.getLast(store.WindSpeedSensor.values) + " m/s",
          BarometerPressure: this.getLast(store.BarometerPressureSensor.values) + " hPa",
        }
      });
    }

    componentDidMount(){
      this.setCurrent(this.props.store);
    }

    componentDidUpdate(prevProps) {
      // console.log(prevProps);
      // Typical usage (don't forget to compare props):
      if (this.props.store.timestamp !== prevProps.store.timestamp) {
        // console.log("update");
        this.setCurrent(this.props.store);
      }
    }

    toggleSide = () => {
      this.setState({ showSide: !this.state.showSide })
    }

  render() {
    return (
      <>
      <div className="content">
          <div className="ccc">
              <div className = "Fright" style={{height:"100%"}}>
                   <LeafletMap callback={this.toggleSide} name="Demo Node"/>
              </div>
              <div className = "Fleft" style={{display: this.state.showSide ? 'block' : 'none'}}>
                  <h2 style={{marginLeft: "0.5em"}}>Demo Node</h2>
                  <Card style={{marginLeft: "1.1em"}}>
                  <CardText>
                  <Table responsive>
                    <thead>
                        <tr>
                            <th className="text-center">Metric</th>
                            <th className="text-center">Current Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-center">AmbientHumidity</td>
                            <td className="text-center">{this.state.lastSensors.AmbientHumidity} </td>
                        </tr>
                        {/*<tr>
                            <td className="text-center">Solar Radiation</td>
                            <td className="text-center">{this.state.lastSensors.UV}</td>
                        </tr>*/}
                        <tr>
                            <td className="text-center">AmbientTemp</td>
                            <td className="text-center">{this.state.lastSensors.AmbientTemp}</td>
                        </tr>
                        {/*<tr>
                            <td className="text-center">BarometerMoisture</td>
                            <td className="text-center">{this.state.lastSensors.BarometerMoisture}</td>
                        </tr>*/}
                        <tr>
                            <td className="text-center">SoilTemp</td>
                            <td className="text-center">{this.state.lastSensors.SoilTemp}</td>
                        </tr>
                        <tr>
                            <td className="text-center">SoilMoisture</td>
                            <td className="text-center">{this.state.lastSensors.SoilMoisture}</td>
                        </tr>
                        <tr>
                            <td className="text-center">BarometerTemp</td>
                            <td className="text-center">{this.state.lastSensors.BarometerTemp}</td>
                        </tr>
                        <tr>
                            <td className="text-center">WindSpeed</td>
                            <td className="text-center">{this.state.lastSensors.WindSpeed}</td>
                        </tr>
                        <tr>
                            <td className="text-center">BarometerPressure</td>
                            <td className="text-center">{this.state.lastSensors.BarometerPressure}</td>
                        </tr>
                    </tbody>
                </Table>
                </CardText>
                </Card>

              </div>

          </div>

      </div>
      </>
    );
  }
}

export default Map;
